export enum SummaryDisplayType {
	PlainText = 1,
	PlainTextScrollable = 2,
	List = 3,
	Questions = 4,
	Preview = 5,
	PopOutList = 6,
	Composite = 7,
	Date = 8,
	DateRange = 9,
	TextWithDetails = 10,
}
